import React from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'badge',
  success: 'badge bg-tg-success/10 text-tg-success border-tg-success/20',
  warning: 'badge bg-yellow-500/10 text-yellow-600 border-yellow-500/20',
  danger: 'badge bg-tg-error/10 text-tg-error border-tg-error/20',
  info: 'badge bg-tg-primary/10 text-tg-primary border-tg-primary/20',
};

export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default',
  className = '' 
}) => {
  return (
    <span className={`${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  );
};

interface StatusBadgeProps {
  enabled: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ enabled }) => {
  return (
    <Badge variant={enabled ? 'success' : 'default'}>
      {enabled ? 'Active' : 'Paused'}
    </Badge>
  );
};
